import { useMemo } from "react";
import { BaseIcon } from "../base-icon/base-icon.component";
import "./bottom-navigation.style.scss";
import { NavLink } from "react-router-dom";
import clsx from "clsx";

function BottomNavigation() {
	const list = useMemo(() => {
		return [
			{
				icon: "Home1",
				title: "خونه",
				path: "/",
			},
			{
				icon: "Cart3",
				title: "فروشگاه",
				path: "/shop",
			},
			{
				icon: "RefreshCircle",
				title: "جمع آوری",
				path: "/new-collection-request",
			},
			{
				icon: "Wallet",
				title: "برداشت",
				path: "/withdraw",
			},
			// {
			// 	icon: "Gift",
			// 	title: "باشگاه",
			// 	path: "/club",
			// },
		];
	}, []);

	return (
		<div className="bottom-navigation">
			{list.map((item) => {
				return (
					<NavLink
						to={item.path}
						key={item.title}
						className={({ isActive }) => {
							return clsx("text-decoration-none text-body bottom-navigation-item flex-fill", {
								active: isActive,
							});
						}}
					>
						<BaseIcon name={item.icon} strokeWidth={1} size={24} className="mb-50" />
						<span className="f-12 fw-400 text-center">{item.title}</span>
						<div className="bottom-navigation-item-hover-layer" />
					</NavLink>
				);
			})}
		</div>
	);
}

export default BottomNavigation;
